import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Maximize2, Minimize2 } from "lucide-react";
import { deepLayerTemplate } from "@/lib/sacred-library/utils/empty-entry";

export function DeepJsonEditor({ value, onChange, error, onError, topicType }) {
  const [text, setText] = useState(() => JSON.stringify(value ?? {}, null, 2));
  const [fullscreen, setFullscreen] = useState(false);

  const apply = () => {
    try {
      const parsed = JSON.parse(text);
      onChange(parsed);
      onError?.(null);
    } catch (e) {
      onError?.(e.message);
    }
  };

  const wrap = fullscreen
    ? "fixed inset-4 z-50 bg-white rounded-lg shadow-2xl p-4 flex flex-col"
    : "relative";

  return (
    <div className={wrap} data-testid="deep-json-editor">
      <div className="flex justify-between items-center mb-2">
        <p className="text-sm font-medium">Deep layer (JSON)</p>
        <div className="flex gap-2 flex-wrap">
          <Button type="button" size="sm" variant="outline" onClick={apply}>
            Apply JSON
          </Button>
          {topicType && (
            <Button
              type="button"
              size="sm"
              variant="ghost"
              onClick={() => {
                const tpl = deepLayerTemplate(topicType);
                setText(JSON.stringify(tpl, null, 2));
                onChange(tpl);
                onError?.(null);
              }}
            >
              Reset template
            </Button>
          )}
          <Button
            type="button"
            size="sm"
            variant="ghost"
            onClick={() => setFullscreen(!fullscreen)}
          >
            {fullscreen ? <Minimize2 className="w-4 h-4" /> : <Maximize2 className="w-4 h-4" />}
          </Button>
        </div>
      </div>
      <p className="text-xs text-muted-foreground mb-2">
        Advanced: tattva, iconography, stories, mantras, puja_vidhi, sadhana_guide, temples, scriptural_refs…
        Edit JSON then click Apply.
      </p>
      {error && <p className="text-xs text-destructive mb-2">{error}</p>}
      <Textarea
        className={`font-mono text-xs ${fullscreen ? "flex-1 min-h-0" : "min-h-[320px]"}`}
        value={text}
        onChange={(e) => setText(e.target.value)}
        spellCheck={false}
      />
    </div>
  );
}
